export default "__VITE_ASSET__MLeG_3DH__"